const Permissions = {
  // Asset
  assetView: 'Asset.AssetView',
  assetLocationAssignment: 'Asset.LocationAssignment',
  assetBundling: 'Asset.AssetBundling',
  assetManagement: 'Asset.AssetManagement',
  assetDeactivation: 'Asset.AssetDeactivation',
  assetStatusChange: 'Asset.StatusChange',
  assetStatusReset: 'Asset.StatusReset',

  // Batch
  batchImport: 'Batch.BatchImport',

  // Asset Definition
  assetTypeView: 'Device.TypeView',
  assetTypeManagement: 'Device.TypeManagement',
  tenantAssetDefinitionView: 'Device.ModelClientView',
  tenantAssetDefinitionManagement: 'Device.ModelClientManagement',
  assetDefinitionView: 'Device.ModelView',
  assetDefinitionManagement: 'Device.ModelManagement',

  // Model
  serviceContractView: 'Device.ServiceContractView',
  serviceContractManagement: 'Device.ServiceContractManagement',

  // Report
  reportView: 'Report.ReportView',

  // Service
  rmaView: 'Service.RmaView',
  rmaVerifyRepair: 'Service.RmaVerifyRepair',
  rmaExchange: 'Service.RmaExchange',
  rmaSendExchange: 'Service.RmaSendExchange',
  rmaRepair: 'Service.RmaRepair',
  rmaSendRepair: 'Service.RmaSendRepair',
  rmaClose: 'Service.RmaClose',
  rmaReceiveDevice: 'Service.RmaReceiveDevice',
  rmaChangeAsset: 'Service.RmaChangeAsset',
  rmaInitialCheck: 'Service.RmaInitialCheck',
  rmaGenerate: 'Service.RmaGenerate',
  rmaUseExternalService: 'Service.RmaUseExternalService',
  rmaSkipServiceCenter: 'Service.RmaSkipServiceCenter',
  rollInView: 'Rollin.RollinView',
  rollInManagement: 'Rollin.RollinManagement',
  rollInClose: 'Rollin.RollinClose',
  rollInReceive: 'Rollin.RollinReceive',

  // Tenant
  tenantView: 'Tenant.TenantView',
  tenantManagement: 'Tenant.TenantManagement',
  serviceProviderView: 'Tenant.ServiceProviderView',
  serviceProviderManagement: 'Tenant.ServiceProviderManagement',
  exchangePoolView: 'Tenant.ExchangePoolView',
  exchangePoolManagement: 'Tenant.ExchangePoolManagement',
  manufacturerView: 'Tenant.ManufacturerView',
  manufacturerManagement: 'Tenant.ManufacturerManagement',

  // User
  userView: 'User.UserView',
  userManagement: 'User.UserManagement',
  roleView: 'User.RoleView',
  roleManagement: 'User.RoleManagement',

  // Language
  languageView: 'Language.LanguageView',
  languageManagement: 'Language.LanguageManagement',
};

export const PermissionKeyService = {
  // Asset
  assetView: Permissions.assetView,
  assetLocationAssignment: Permissions.assetLocationAssignment,
  assetBundling: Permissions.assetBundling,
  assetManagement: Permissions.assetManagement,
  assetDeactivation: Permissions.assetDeactivation,
  assetStatusChange: Permissions.assetStatusChange,
  assetStatusReset: Permissions.assetStatusReset,

  // Batch
  batchImport: Permissions.batchImport,

  // Asset Definition
  assetTypeView: Permissions.assetTypeView,
  assetTypeManagement: Permissions.assetTypeManagement,
  tenantAssetDefinitionView: Permissions.tenantAssetDefinitionView,
  tenantAssetDefinitionManagement: Permissions.tenantAssetDefinitionManagement,
  assetDefinitionView: Permissions.assetDefinitionView,
  assetDefinitionManagement: Permissions.assetDefinitionManagement,

  // Model
  serviceContractView: Permissions.serviceContractView,
  serviceContractManagement: Permissions.serviceContractManagement,

  // Report
  reportView: Permissions.reportView,

  // Service
  rmaView: Permissions.rmaView,
  rmaVerifyRepair: Permissions.rmaVerifyRepair,
  rmaExchange: Permissions.rmaExchange,
  rmaSendExchange: Permissions.rmaSendExchange,
  rmaRepair: Permissions.rmaRepair,
  rmaSendRepair: Permissions.rmaSendRepair,
  rmaClose: Permissions.rmaClose,
  rmaReceiveDevice: Permissions.rmaReceiveDevice,
  rmaChangeAsset: Permissions.rmaChangeAsset,
  rmaInitialCheck: Permissions.rmaInitialCheck,
  rmaUseExternalService: Permissions.rmaUseExternalService,
  rmaSkipServiceCenter: Permissions.rmaSkipServiceCenter,
  rmaGenerate: Permissions.rmaGenerate,
  rollInView: Permissions.rollInView,
  rollInManagement: Permissions.rollInManagement,
  rollInClose: Permissions.rollInClose,
  rollInReceive: Permissions.rollInReceive,

  // Tenant
  tenantView: Permissions.tenantView,
  tenantManagement: Permissions.tenantManagement,
  serviceProviderView: Permissions.serviceProviderView,
  serviceProviderManagement: Permissions.serviceProviderManagement,
  exchangePoolView: Permissions.exchangePoolView,
  exchangePoolManagement: Permissions.exchangePoolManagement,
  manufacturerView: Permissions.manufacturerView,
  manufacturerManagement: Permissions.manufacturerManagement,

  // User
  userView: Permissions.userView,
  userManagement: Permissions.userManagement,
  roleView: Permissions.roleView,
  roleManagement: Permissions.roleManagement,

  // Language
  languageView: Permissions.languageView,
  languageManagement: Permissions.languageManagement,

  // --- Compound keys ---

  // Aside menu
  asideViewAsset: [
    Permissions.assetLocationAssignment,
    Permissions.serviceContractManagement,
    Permissions.rollInManagement,
    Permissions.rollInReceive,
  ],
  asideViewRma: [Permissions.rmaVerifyRepair],
  asideViewUser: [Permissions.userManagement, Permissions.roleView],
};
